module.exports = __webpack_public_path__ + "img/mesa_el_e.970c49bc.png";